module.exports = __webpack_public_path__ + "static/img/client2.0fe232bd.jpeg";